export const TIMESHIFTING_NPAW_SHIFTING_TIME_MARGIN = 60;
export const TIMESHIFTING_NPAW_LIVE_TIME_MARGIN = 50;
export const YOUBORA_TRIGGER_START_SESSION = 'newYouboraSession';
